/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplePayBillingContact } from './ApplePayBillingContact';
import {
    ApplePayBillingContactFromJSON,
    ApplePayBillingContactFromJSONTyped,
    ApplePayBillingContactToJSON,
    ApplePayBillingContactToJSONTyped,
} from './ApplePayBillingContact';
import type { ApplePayPaymentData } from './ApplePayPaymentData';
import {
    ApplePayPaymentDataFromJSON,
    ApplePayPaymentDataFromJSONTyped,
    ApplePayPaymentDataToJSON,
    ApplePayPaymentDataToJSONTyped,
} from './ApplePayPaymentData';
import type { ApplePayPaymentMethodInfo } from './ApplePayPaymentMethodInfo';
import {
    ApplePayPaymentMethodInfoFromJSON,
    ApplePayPaymentMethodInfoFromJSONTyped,
    ApplePayPaymentMethodInfoToJSON,
    ApplePayPaymentMethodInfoToJSONTyped,
} from './ApplePayPaymentMethodInfo';

/**
 * Payload forwarded by VGS to this endpoint (upstream) after decrypting and tokenizing
 * the Apple Pay token. VGS must send snake_case property names to match this schema.
 * All properties below are optional; the API returns 400 if required payment fields
 * are missing after validation.
 * 
 * @export
 * @interface ApplePayTokenizedPayload
 */
export interface ApplePayTokenizedPayload {
    /**
     * Tokenized PAN (alias). Accepted keys include cardNumberTokenized, pan_tokenized, payment.card_number_tokenized.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    cardNumberTokenized?: string;
    /**
     * Tokenized CVC. Accepted keys include cardCvcTokenized, cvc_tokenized, payment.card_cvc_tokenized.
     * Optional for Apple Pay (cryptogram replaces CVC); backend stores empty string when missing.
     * 
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    cardCvcTokenized?: string;
    /**
     * Two-digit month (e.g. "12"). Accepted keys include expirationMonth, exp_month, expiry_month.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    expirationMonth?: string;
    /**
     * Two-digit year (e.g. "28"). Accepted keys include expirationYear, exp_year, expiry_year.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    expirationYear?: string;
    /**
     * Accepted keys include cardholderFirstName, billingContact.givenName.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    cardholderFirstName?: string;
    /**
     * Accepted keys include cardholderLastName, billingContact.familyName.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    cardholderLastName?: string;
    /**
     * Accepted keys include billingAddressLine1, billing_address.address1.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    billingAddressLine1?: string;
    /**
     * Accepted keys include billingAddressLine2, billingContact.subLocality.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    billingAddressLine2?: string;
    /**
     * Accepted keys include billingAddressCity, billingContact.locality.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    billingAddressCity?: string;
    /**
     * Accepted keys include billingAddressState, billingContact.administrativeArea.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    billingAddressState?: string;
    /**
     * Accepted keys include billingAddressZip, billingContact.postalCode.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    billingAddressZip?: string;
    /**
     * ISO country code. Accepted keys include billingAddressCountry, billingContact.countryCode. Defaults to US if missing.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    billingAddressCountry?: string;
    /**
     * Network/brand (e.g. visa, mastercard, amex, discover). Accepted keys include cardProvider, network, brand, paymentMethod.network.
     * @type {string}
     * @memberof ApplePayTokenizedPayload
     */
    cardProvider?: string;
    /**
     * 
     * @type {ApplePayBillingContact}
     * @memberof ApplePayTokenizedPayload
     */
    billingContact?: ApplePayBillingContact;
    /**
     * 
     * @type {ApplePayPaymentMethodInfo}
     * @memberof ApplePayTokenizedPayload
     */
    paymentMethod?: ApplePayPaymentMethodInfo;
    /**
     * 
     * @type {ApplePayPaymentData}
     * @memberof ApplePayTokenizedPayload
     */
    payment?: ApplePayPaymentData;
}

/**
 * Check if a given object implements the ApplePayTokenizedPayload interface.
 */
export function instanceOfApplePayTokenizedPayload(value: object): value is ApplePayTokenizedPayload {
    return true;
}

export function ApplePayTokenizedPayloadFromJSON(json: any): ApplePayTokenizedPayload {
    return ApplePayTokenizedPayloadFromJSONTyped(json, false);
}

export function ApplePayTokenizedPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplePayTokenizedPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'cardNumberTokenized': json['card_number_tokenized'] == null ? undefined : json['card_number_tokenized'],
        'cardCvcTokenized': json['card_cvc_tokenized'] == null ? undefined : json['card_cvc_tokenized'],
        'expirationMonth': json['expiration_month'] == null ? undefined : json['expiration_month'],
        'expirationYear': json['expiration_year'] == null ? undefined : json['expiration_year'],
        'cardholderFirstName': json['cardholder_first_name'] == null ? undefined : json['cardholder_first_name'],
        'cardholderLastName': json['cardholder_last_name'] == null ? undefined : json['cardholder_last_name'],
        'billingAddressLine1': json['billing_address_line_1'] == null ? undefined : json['billing_address_line_1'],
        'billingAddressLine2': json['billing_address_line_2'] == null ? undefined : json['billing_address_line_2'],
        'billingAddressCity': json['billing_address_city'] == null ? undefined : json['billing_address_city'],
        'billingAddressState': json['billing_address_state'] == null ? undefined : json['billing_address_state'],
        'billingAddressZip': json['billing_address_zip'] == null ? undefined : json['billing_address_zip'],
        'billingAddressCountry': json['billing_address_country'] == null ? undefined : json['billing_address_country'],
        'cardProvider': json['card_provider'] == null ? undefined : json['card_provider'],
        'billingContact': json['billingContact'] == null ? undefined : ApplePayBillingContactFromJSON(json['billingContact']),
        'paymentMethod': json['paymentMethod'] == null ? undefined : ApplePayPaymentMethodInfoFromJSON(json['paymentMethod']),
        'payment': json['payment'] == null ? undefined : ApplePayPaymentDataFromJSON(json['payment']),
    };
}

export function ApplePayTokenizedPayloadToJSON(json: any): ApplePayTokenizedPayload {
    return ApplePayTokenizedPayloadToJSONTyped(json, false);
}

export function ApplePayTokenizedPayloadToJSONTyped(value?: ApplePayTokenizedPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_number_tokenized': value['cardNumberTokenized'],
        'card_cvc_tokenized': value['cardCvcTokenized'],
        'expiration_month': value['expirationMonth'],
        'expiration_year': value['expirationYear'],
        'cardholder_first_name': value['cardholderFirstName'],
        'cardholder_last_name': value['cardholderLastName'],
        'billing_address_line_1': value['billingAddressLine1'],
        'billing_address_line_2': value['billingAddressLine2'],
        'billing_address_city': value['billingAddressCity'],
        'billing_address_state': value['billingAddressState'],
        'billing_address_zip': value['billingAddressZip'],
        'billing_address_country': value['billingAddressCountry'],
        'card_provider': value['cardProvider'],
        'billingContact': ApplePayBillingContactToJSON(value['billingContact']),
        'paymentMethod': ApplePayPaymentMethodInfoToJSON(value['paymentMethod']),
        'payment': ApplePayPaymentDataToJSON(value['payment']),
    };
}

